import AboutHero from "../components/aboutHero";
import AboutStory from "../components/AboutStory";
import AboutAdvantages from "../components/AboutAdvantages";
import AboutProcess from '../components/AboutProcess.jsx';
const About = () => {
    return (
        <section>
            <AboutHero/>
            <AboutStory/>
            <AboutAdvantages/>
            <AboutProcess/>
        </section>
    )
}
export default About